import {
	PatchRefundUpdateRequest,
	PatchRefundUpdateRequestParams,
	PatchRefundUpdateRequestResponse,
} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRefundPatchUpdateRequest implements PatchRefundUpdateRequest {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PatchRefundUpdateRequestResponse>,
	) {}

	async patch(params: PatchRefundUpdateRequestParams): Promise<PatchRefundUpdateRequestResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
